import { queryOptions, useMutation, useQueryClient } from '@tanstack/react-query'
import { useMemo } from 'react'
import { useAuthStore } from '@/features/auth/store'
import { fetchProfile } from './api'
import { createProfileCompletionSaver } from './complete-profile'

export const profileKeys = {
  detail: (accountId: string) => ['liotitip-profile', accountId] as const,
  completion: (accountId: string) => ['liotitip-profile-completion', accountId] as const,
}

export function profileQueryOptions(accountId: string) {
  return queryOptions({
    queryKey: profileKeys.detail(accountId),
    queryFn: ({ signal }) => fetchProfile(signal),
    enabled: Boolean(accountId),
    // Share one server snapshot across the gate, sidebar and shipping until explicitly updated.
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
}

export function useCompleteProfile(accountId: string) {
  const queryClient = useQueryClient()
  const save = useMemo(
    () =>
      createProfileCompletionSaver(() => {
        if (useAuthStore.getState().session?.user.id !== accountId) {
          throw new Error('Sesi berubah. Silakan masuk kembali.')
        }
      }),
    [accountId],
  )
  return useMutation({
    mutationKey: profileKeys.completion(accountId),
    mutationFn: save,
    retry: false,
    onSuccess: (profile) => {
      if (useAuthStore.getState().session?.user.id !== accountId) return
      queryClient.setQueryData(profileKeys.detail(accountId), profile)
    },
  })
}
